import React from 'react';

import s from './style.module.css';

type LargeHeading1Props = {
    title: string;
};

export const LargeHeading2 = (props: LargeHeading1Props) => {
    return <h2 className={s.heading}>{props.title}</h2>;
};

export default LargeHeading2;
